import { routerReducer } from 'react-router-redux';
import { createStore, combineReducers, applyMiddleware, GenericStoreEnhancer } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';

import app from './reducers/App';
import auth from './reducers/Auth';
import password from './reducers/Password';
import moffAPI from './reducers/MoffAPI';
import { moffCheck, moffCheckCount } from './reducers/MoffCheck';
import { barthelIndex } from './reducers/BarthelIndex';
import { hdsr } from './reducers/HDSR';
import appUser from './reducers/AppUser';
import interestCheck from './reducers/InterestCheck';
import login from './reducers/Login';
import dialog from './reducers/Dialog';
import request_param from './reducers/RequestParam';
import header from './reducers/Header';
// import error from './reducers/Error';

import { reducer as formReducer } from 'redux-form';

const loggerMiddleware = createLogger;
let middleware: GenericStoreEnhancer;

if (process.env.NODE_ENV !== 'production') {
  // 開発.
  middleware = applyMiddleware(
    thunkMiddleware,
    loggerMiddleware,
  );
} else {
  // 製品版はログを使わない.
  middleware = applyMiddleware(
    thunkMiddleware,
  );
}

export default function configureStore() {
  return createStore(
    combineReducers({
      app: app,
      auth: auth,
      password: password,
      moffAPI: moffAPI,
      moffCheck: moffCheck,
      barthelIndex: barthelIndex,
      hdsr: hdsr,
      moffCheckCount: moffCheckCount,
      appUser: appUser,
      interestCheck: interestCheck,
      login: login,
      dialog: dialog,
      header: header,
      request_param: request_param,
      // error: error,
      // signFormの formとの連携
      form: formReducer,
      routing: routerReducer,
    }),
    middleware
  );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.tsx